import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './dealer-carousel-arrows.scss';

export const PrevArrow = ({ disabled = false, onClick = null }) => (
  <div className="dealer-carousel-arrow left carousel-control me-2_5">
    <button
      aria-label="previous slide"
      className={classnames('btn border-0 btn-prev', {
        'slick-disabled': disabled,
      })}
      onClick={onClick}
      disabled={disabled}
    >
      <i
        className="icon-arrow-left3 icon text-cool-gray-30 size-16 w-100 h-100 d-flex justify-content-center align-items-center"
        aria-hidden
      />
    </button>
  </div>
);
PrevArrow.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export const NextArrow = ({ disabled = false, onClick = null }) => (
  <div className="dealer-carousel-arrow right carousel-control">
    <button
      aria-label="next slide"
      className={classnames('btn border-0 btn-next', {
        'slick-disabled': disabled,
      })}
      onClick={onClick}
      disabled={disabled}
    >
      <i
        className="icon-arrow-right3 icon text-cool-gray-30 size-16 w-100 h-100 d-flex justify-content-center align-items-center"
        aria-hidden
      />
    </button>
  </div>
);
NextArrow.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
